import './RectLabelOverlay.css';
export var rectLabelClipWrapper = '_1a48u8w2-3-12-1';
export var rectLabelSpan = '_1a48u8w1-3-12-1';
export var rectOverlayContainer = '_1a48u8w0-3-12-1';